import type { ReactNode } from "react";

export type RadiusScale = "sharp" | "default" | "round";
export type SurfaceTone = "white" | "warm" | "cool";

export type MapTalesTheme = {
	accentScale?: {
		300: string;
		400: string;
		500: string;
		600: string;
		700: string;
		tint: string;
	};
	secondaryScale?: {
		500: string;
		tint: string;
		on: string;
	};
	logo?: ReactNode;
	fontSans?: string;
	fontDisplay?: string;
	radius?: RadiusScale;
	surface?: SurfaceTone;
};

type Props = {
	theme?: MapTalesTheme;
	children: ReactNode;
};

export function Provider({ theme, children }: Props) {
	const cssVars: Record<string, string> = {};

	if (theme?.accentScale) {
		cssVars["--accent-300"] = theme.accentScale[300];
		cssVars["--accent-400"] = theme.accentScale[400];
		cssVars["--accent-500"] = theme.accentScale[500];
		cssVars["--accent-600"] = theme.accentScale[600];
		cssVars["--accent-700"] = theme.accentScale[700];
		cssVars["--accent-tint"] = theme.accentScale.tint;
	}

	if (theme?.secondaryScale) {
		cssVars["--secondary-500"] = theme.secondaryScale[500];
		cssVars["--secondary-tint"] = theme.secondaryScale.tint;
		cssVars["--secondary-on"] = theme.secondaryScale.on;
	}

	if (theme?.fontSans) {
		cssVars["--font-sans"] = theme.fontSans;
	}

	if (theme?.fontDisplay) {
		cssVars["--font-display"] = theme.fontDisplay;
	}

	return (
		<div
			style={cssVars as React.CSSProperties}
			data-radius={theme?.radius ?? "default"}
			data-surface={theme?.surface ?? "white"}
		>
			{children}
		</div>
	);
}
